var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.currentPrivacyHints.length
      ? _c("div", { ref: "formCheck", staticClass: "form-check" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              id: "shipping-service-privacy-accept" + _vm._uid
            },
            domProps: { checked: _vm.shippingPrivacyHintAccepted },
            on: {
              change: function($event) {
                return _vm.setValue($event.target.checked)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "shipping-service-privacy-accept" + _vm._uid }
            },
            [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.privacyHintContent) }
              })
            ]
          )
        ])
      : _c("div", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }